import * as scheduleApi from '@/api/schedule';

export default {
    namespaced: true,
    state: {
        recordingChannels: [],
        schedules: [],
        gridDate: {
            start: '',
            end: '',
        },
    },
    getters: {
        recordingChannels: state => state.recordingChannels,
        selectedRecordingChannels: state => state.recordingChannels.filter(el => el.checked).map(el => el.id),
        schedules: state => state.schedules,
        gridDateStart: state => state.gridDate.start,
        gridDateEnd: state => state.gridDate.end,
    },
    mutations: {
        setInitRecordingChannels(state, payload) {
            state.recordingChannels = payload.map(el => ({
                ...el,
                checked: true,
            }));
        },
        setRecodingChannelsAllChecked(state, payload) {
            state.recordingChannels = state.recordingChannels.map(el => ({
                ...el,
                checked: payload,
            }));
        },
        setRecordingChannelChecked(state, payload) {
            state.recordingChannels[payload.index].checked = payload.checked;
        },
        setSchedules(state, payload) {
            state.schedules = payload.map((el, sortIdx) => {
                const channelIndex = state.recordingChannels.findIndex(channel => el.live_media_channel.id === channel.id);
                return {
                    ...el,
                    textColor: '#000 !important',
                    bgClassName: `channel-${channelIndex + 1}`,
                    sortIdx,
                };
            });
        },
        setGridDate(state, { start, end }) {
            state.gridDate = {
                start,
                end,
            };
        },
    },
    actions: {
        async fetchRecordingChannels({ commit }) {
            const response = await scheduleApi.fetchRecordingChannels();

            commit('setInitRecordingChannels', response.data.data);
        },

        async fetchSchedules({ getters, commit, dispatch }) {
            if (getters.recordingChannels.length === 0) {
                await dispatch('fetchRecordingChannels');
            }

            const params = {
                start: getters.gridDateStart,
                end: getters.gridDateEnd,
                channel_ids: getters.selectedRecordingChannels.length > 0 ? getters.selectedRecordingChannels : [0],
            };
            const response = await scheduleApi.fetchSchedules(params);

            commit('setSchedules', response.data.data);
        },
    },
};
